import React from 'react'
import {useAsyncDebounce} from 'react-table'
import {Form} from 'react-bootstrap'
 
function GlobalFilter({ preGlobalFilteredRows, globalFilter, setGlobalFilter}) {
    const count = preGlobalFilteredRows.length;
    const [value, setValue] = React.useState(globalFilter);
    const onChange = useAsyncDebounce(value => {
        setGlobalFilter(value || undefined)
    }, 200)

    return (
        <Form.Group>
            <Form.Control type="text"
                value={value || ""}
                onChange={e => {
                    setValue(e.target.value);
                    onChange(e.target.value);
                }} className="textbox-back"
                placeholder={`Search`}
                style={{ width: '170px' }}
            />
        </Form.Group>
    )
}

export default GlobalFilter
